import React, { Component } from 'react';

import Highcharts from 'highcharts';

export class Chart extends Component 
{
	componentDidMount()
	{
		Highcharts.chart(this.props.id, {
			chart: {
				type: 'line',
				animation: this.props.animation,//Highcharts.svg, // don't animate in old IE
				marginRight: 10,
				events: {
					load: (function(state, props) {
						return function () {
							// set up the updating of the chart
							props.data.series = this.series[0];
						}
					}(this.state, this.props))
				}
			},
			title: {
				text: this.props.name
			},
			xAxis: {
				allowDecimals: false,
				type: 'linear',
				//minTickInterval: 1,
				tickAmount: 50,
			},
			yAxis: {
				softMax: this.props.yStartMax,
				softMin: 0,
				title: {
					text: this.props.name
				},
				plotLines: [{
					width: 1,
					color: '#808080'
				}]
			},
			tooltip: {
				formatter: function () {
					return '<b>' + this.series.name + '</b><br/>Day ' + this.x + '<br/>' +
						this.y.toLocaleString();
				}
			},
			legend: {
				enabled: false
			},
			exporting: {
				enabled: false
			},
			series: [{
				type: 'line',
				cropThreshold: 100,
				name: this.props.name,
				data: (function (props) {
					return props.data.startData;
				}(this.props))
			}]
		});
	}

  	render() {
		return (
			<div>
				<div id={this.props.id}></div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/Chart.js